<template>
  <div class="root">
    <div>
      <p style="margin-top:12pt; margin-bottom:12pt; background-color:#ffffff">
        <span style="color:#444444">更新日期： </span
        ><span style="font-family:'Helvetica Neue'; color:#444444">2022</span
        ><span style="color:#444444">年</span
        ><span style="font-family:'Helvetica Neue'; color:#444444">10</span
        ><span style="color:#444444">月</span
        ><span style="font-family:'Helvetica Neue'; color:#444444">17</span
        ><span style="color:#444444">日</span><br /><span style="color:#444444">生效日期： </span
        ><span style="font-family:'Helvetica Neue'; color:#444444">2022</span
        ><span style="color:#444444">年</span
        ><span style="font-family:'Helvetica Neue'; color:#444444">10</span
        ><span style="color:#444444">月</span
        ><span style="font-family:'Helvetica Neue'; color:#444444">17</span
        ><span style="color:#444444">日</span>
      </p>
      <p
        style="margin-top:12pt; margin-bottom:12pt; text-align:left; widows:2; orphans:2; font-size:12pt; background-color:#ffffff"
      >
        <span style="font-family:宋体; font-weight:bold; color:#444444">导言</span>
      </p>
      <p
        style="margin-top:12pt; margin-bottom:12pt; text-align:left; widows:2; orphans:2; font-size:12pt; background-color:#ffffff"
      >
        <span style="font-family:宋体; font-weight:bold; color:#444444">欢迎您使用</span
        ><span style="font-family:Helvetica; font-weight:bold; color:#444444">“咔嚓”</span
        ><span style="font-family:宋体; font-weight:bold; color:#444444">软件及相关服务！</span>
      </p>
      <p
        style="margin-top:12pt; margin-bottom:12pt; text-align:left; widows:2; orphans:2; font-size:12pt; background-color:#ffffff"
      >
        <b
          >《“咔嚓”用户协议》（以下简称“本协议”）是您与“咔嚓”的运营主体[天津你说的都对科技有限公司]（下称“我们”）就您下载、安装、注册、登录、使用（以下统称“使用”）“咔嚓”软件，并获得“咔嚓”软件提供的相关服务所订立的协议。</b
        >
      </p>
      <p
        style="margin-top:12pt; margin-bottom:12pt; text-align:left; widows:2; orphans:2; font-size:12pt; background-color:#ffffff"
      >
        <span style="font-family:宋体; color:#444444">为了更好地为您提供服务，请您在开始使用</span
        ><span style="font-family:Helvetica; color:#444444">“咔嚓”</span
        ><span style="font-family:宋体; color:#444444"
          >软件及相关服务之前，认真阅读并充分理解本协议的内容，特别是涉及免除或者限制责任的条款、权利许可和信息使用的条款及法律适用和争议解决条款等。其中，免除或者限制责任条款等重要内容将以加粗形式提示您注意，您应重点阅读。</span
        >
      </p>
      <p
        style="margin-top:12pt; margin-bottom:12pt; text-align:left; widows:2; orphans:2; font-size:12pt; background-color:#ffffff"
      >
        <span style="font-family:宋体; color:#444444"
          >如您不同意本协议，将导致我们无法为您提供完整的产品和服务，您也可以选择停止使用。如您自主选择同意或使用“咔嚓”软件及相关服务，则视为您已充分理解本协议，并同意作为本协议的一方当事人接受本协议以及其他与“咔嚓”软件及相关服务相关的协议和规则（包括但不限于</span
        ><span style="font-family:Helvetica; color:#444444">
          <a href="#cuePrivacy" target="_blank">《“咔嚓”隐私政策》</a>和所有</span
        ><span style="font-family:Helvetica; color:#444444">”咔嚓”</span
        ><span style="font-family:宋体; color:#444444"
          >已经发布或未来可能发布的各类规则、公告或通知）的约束。</span
        >
      </p>
      <p
        style="margin-top:12pt; margin-bottom:12pt; text-align:left; widows:2; orphans:2; font-size:12pt; background-color:#ffffff"
      >
        <span style="font-family:宋体; color:#444444"
          >如果您是未满18周岁的未成年人，请在监护人的陪同下阅读并理解本协议及上述其他协议。特别地，如果你是未满14周岁的未成年人，还应请您的监护人仔细阅读
          <a href="#cuePrivacy" target="_blank">《“咔嚓”隐私政策》</a
          >中关于未成年人的相关条款，只有在征得您的监护人的同意后，您方可使用</span
        ><span style="font-family:Helvetica; color:#444444">“咔嚓”</span
        ><span style="font-family:宋体; color:#444444">软件及相关服务。</span>
      </p>
      <p
        style="margin-top:12pt; margin-bottom:12pt; text-align:left; widows:2; orphans:2; font-size:12pt; background-color:#ffffff"
      >
        <span style="font-family:宋体; font-weight:bold; color:#444444">特别提示：</span>
      </p>
      <p
        style="margin-top:12pt; margin-bottom:12pt; text-align:left; widows:2; orphans:2; font-size:12pt; background-color:#ffffff"
      >
        您基于本协议及您使用“咔嚓”的相关服务而授权给“咔嚓”的相关内容（包括您上传的图片、分享、发布的信息、或展示地理位置以及提供的个人信息等），“咔嚓”仅限用于为您提供拍摄、分享展示和评论的服务，相关内容将严格按相关法律法规的规定保留在“咔嚓”上，除非为了改善“咔嚓”为您提供的服务或另行取得您的再次同意，否则“咔嚓”不会以任何其他形式或目的使用上述内容。
      </p>
      <p
        style="margin-top:12pt; margin-bottom:12pt; text-align:left; widows:2; orphans:2; font-size:12pt; background-color:#ffffff"
      >
        同时，您可以依据“咔嚓”平台规则修改、撤回或删除上述内容，在您撤回或删除上述内容后，“咔嚓”将依据相关法律法规的规定在服务器上删除相关内容。
      </p>
      <ol type="1" style="margin:0pt; padding-left:0pt">
        <li
          style="margin-top:12pt; margin-bottom:12pt; text-align:left; widows:2; orphans:2; font-family:Helvetica; font-size:12pt; font-weight:bold; color:#444444; background-color:#ffffff"
        >
          <span style="font-family:宋体">1.服务内容</span>
        </li>
      </ol>
      <p
        style="margin-top:12pt; margin-left:18pt; margin-bottom:12pt; text-align:left; widows:2; orphans:2; font-size:12pt; background-color:#ffffff"
      >
        “咔嚓”是一个照片分享社交网络，您可以通过“咔嚓”拍摄好友的照片，经好友同意后发布到好友的个人主页上，以及可以给照片进行点赞和评论。“咔嚓”只允许您将照片发布到好友的个人主页上，您的个人照片资料仅由好友们拍摄发布的照片组成（以下简称“本服务”）。
      </p>
      <ol start="2" type="1" style="margin:0pt; padding-left:0pt">
        <li
          style="margin-top:12pt; margin-bottom:12pt; text-align:left; widows:2; orphans:2; font-family:Helvetica; font-size:12pt; font-weight:bold; color:#444444; background-color:#ffffff"
        >
          <span style="font-family:宋体">2.用户个人信息保护</span>
        </li>
      </ol>
      <p
        style="margin-top:12pt; margin-left:18pt; margin-bottom:12pt; text-align:left; widows:2; orphans:2; font-size:12pt; background-color:#ffffff"
      >
        <span style="font-family:宋体; color:#444444">我们与您一同致力于您个人信息的保护。</span>
      </p>
      <p
        style="margin-top:12pt; margin-left:18pt; margin-bottom:12pt; text-align:left; widows:2; orphans:2; font-size:12pt; background-color:#ffffff"
      >
        <span style="font-family:宋体; color:#444444"
          >保护用户个人信息是我们的基本原则之一，在使用</span
        ><span style="font-family:Helvetica; color:#444444">“咔嚓”</span
        ><span style="font-family:宋体; color:#444444"
          >软件及相关服务的过程中，您可能需要提供您的个人信息（包括但不限于您的电话号码、设备信息等），以便我们向您提供更好的服务和相应的技术支持。我们将依法保护您浏览、修改、删除相关个人信息以及撤回授权的权利，并将运用加密技术、匿名化处理等其他与</span
        ><span style="font-family:Helvetica; color:#444444">“咔嚓”</span
        ><span style="font-family:宋体; color:#444444"
          >软件及相关服务相匹配的技术措施及其他安全措施保护您的个人信息。</span
        >
      </p>
      <p
        style="margin-top:12pt; margin-left:18pt; margin-bottom:12pt; text-align:left; widows:2; orphans:2; font-size:12pt; background-color:#ffffff"
      >
        <span style="font-family:宋体; color:#444444"
          >更多关于您个人信息保护的内容，请参看
          <a href="#cuePrivacy" target="_blank">《“咔嚓”隐私政策》</a>。</span
        >
      </p>
      <ol start="3" type="1" style="margin:0pt; padding-left:0pt">
        <li
          style="margin-top:12pt;  margin-bottom:12pt; text-align:left; widows:2; orphans:2;  font-family:Helvetica; font-size:12pt; font-weight:bold; color:#444444; background-color:#ffffff"
        >
          <span style="font-family:宋体">3.关于</span><span>“</span
          ><span style="font-family:宋体">帐号</span><span>”</span>
          <ol type="1" class="awlist1" style="margin-right:0pt; margin-left:0pt; padding-left:0pt">
            <li
              style="margin-top:12pt; margin-left:22.5pt; margin-bottom:12pt; text-indent:-22.5pt; font-weight:normal; background-color:#ffffff; "
            >
              <span
                >3.1
                您在使用本服务前需要注册一个“咔嚓”帐号，“咔嚓”帐号可以通过手机号码进行注册，“咔嚓”软件及相关服务为您提供了注册通道，在注册成功后您有权选择合法的字符组合作为自己的帐号，您在注册时提供的手机号码是您以注册用户身份登录并使用
                “咔嚓”软件及相关服务的凭证。</span
              >
            </li>
            <li
              style="margin-top:12pt; margin-left:22.5pt; margin-bottom:12pt; text-indent:-22.5pt; font-weight:normal; background-color:#ffffff; -aw-list-padding-sml:7.5pt"
            >
              <span
                style="width:7.5pt; font:7pt 'Times New Roman'; display:inline-block; -aw-import:ignore"
              ></span
              ><span style="font-family:宋体">3.2 帐号注销：在需要终止使用</span><span>“咔嚓”</span
              ><span style="font-family:宋体">帐号服务时，符合以下条件的，您可以申请注销您的</span
              ><span>“咔嚓”</span><span style="font-family:宋体">帐号：</span>
            </li>
          </ol>
        </li>
      </ol>
      <p
        style="margin-top:12pt; margin-left:24pt; margin-bottom:12pt; text-align:left; widows:2; orphans:2; font-size:12pt; background-color:#ffffff"
      >
        <span style="font-family:宋体; color:#444444">（</span
        ><span style="font-family:Helvetica; color:#444444">1</span
        ><span style="font-family:宋体; color:#444444">）您仅能申请注销您本人的帐号，并依照</span
        ><span style="font-family:Helvetica; color:#444444">“咔嚓”</span
        ><span style="font-family:宋体; color:#444444">的流程进行注销；</span>
      </p>
      <p
        style="margin-top:12pt; margin-left:24pt; margin-bottom:12pt; text-align:left; widows:2; orphans:2; font-size:12pt; background-color:#ffffff"
      >
        <span style="font-family:宋体; color:#444444">（</span
        ><span style="font-family:Helvetica; color:#444444">2</span
        ><span style="font-family:宋体; color:#444444">）您仍应对您在注销帐号前且使用</span
        ><span style="font-family:Helvetica; color:#444444">“咔嚓”</span
        ><span style="font-family:宋体; color:#444444">服务期间的行为承担相应责任；</span>
      </p>
      <p
        style="margin-top:12pt; margin-left:24pt; margin-bottom:12pt; text-align:left; widows:2; orphans:2; font-size:12pt; background-color:#ffffff"
      >
        <span style="font-family:宋体; color:#444444">（</span
        ><span style="font-family:Helvetica; color:#444444">3</span
        ><span style="font-family:宋体; color:#444444"
          >）注销成功后，帐号记录、功能等将无法恢复或提供。</span
        >
      </p>
      <p
        style="margin-top:12pt; margin-left:40.5pt; margin-bottom:12pt; text-align:left; widows:2; orphans:2; font-size:12pt; background-color:#ffffff"
      >
        <span style="font-family:宋体; color:#444444">（</span
        ><span style="font-family:Helvetica; color:#444444">4</span
        ><span style="font-family:宋体; color:#444444">）您的帐号注销成功后，</span
        ><span style="font-family:Helvetica; color:#444444">14</span
        ><span style="font-family:宋体; color:#444444">日内无法再注册新的</span
        ><span style="font-family:Helvetica; color:#444444">“咔嚓”</span
        ><span style="font-family:宋体; color:#444444">帐号。</span>
      </p>
      <p
        style="margin-top:12pt; margin-left:40.5pt; margin-bottom:12pt; text-align:left; widows:2; orphans:2; font-size:12pt; background-color:#ffffff"
      >
        <span style="font-family:宋体; color:#444444">如您需要注销您的</span
        ><span style="font-family:Helvetica; color:#444444">“咔嚓”</span
        ><span style="font-family:宋体; color:#444444">帐号，请打开</span
        ><span style="font-family:Helvetica; color:#444444">咔嚓</span
        ><span style="font-family:宋体; color:#444444"
          >客户端，在您的用户个人页面中依次点击“主界面右下角个人页面</span
        ><span style="font-family:Helvetica; color:#444444">-</span
        ><span style="font-family:宋体; color:#444444">设置</span
        ><span style="font-family:Helvetica; color:#444444">-</span
        ><span style="font-family:宋体; color:#444444">注销帐户</span
        ><span style="font-family:Helvetica; color:#444444">”</span
        ><span style="font-family:宋体; color:#444444"
          >来注销帐号。您确认注销账号是不可恢复的操作，您应自行备份与账号相关的信息和数据，您确认操作之前与账号相关的所有服务均已进行妥善处理。您确认并同意注销账号后并不代表本账号注销前的账号行为和相关责任得到豁免或减轻，如在注销期间，您的账号被他人投诉、被国家机关调查或者正处于诉讼、仲裁程序中，“</span
        ><span style="font-family:Helvetica; color:#444444">咔嚓</span
        ><span style="font-family:宋体; color:#444444">”有权自行终止用户的账号注销。</span>
      </p>
      <div style="margin-top:12pt; margin-left:18pt; margin-bottom:12pt; background-color:#ffffff">
        <p
          style="margin-top:0pt; margin-left:22.5pt; margin-bottom:0pt; text-indent:-22.5pt; text-align:left; widows:2; orphans:2; font-size:12pt; -aw-import:list-item; -aw-list-level-number:1; -aw-list-number-format:'%0.%1'; -aw-list-number-styles:'decimal decimal'; -aw-list-number-values:'3 3'; -aw-list-padding-sml:7.5pt"
        >
          <span style="-aw-import:ignore"
            ><span style="font-family:Helvetica; font-weight:bold; color:#444444">3.3</span
            ><span
              style="width:7.5pt; font:7pt 'Times New Roman'; display:inline-block; -aw-import:spaces"
              >&nbsp;&nbsp;&nbsp;&nbsp;
            </span></span
          ><span style="font-family:宋体; font-weight:bold; color:#444444"
            >您理解并承诺，您所设置的帐号不得违反国家法律法规及</span
          ><span style="font-family:Helvetica; font-weight:bold; color:#444444">“咔嚓”</span
          ><span style="font-family:宋体; font-weight:bold; color:#444444"
            >的相关规则，您的帐号名称、头像等注册信息及其他个人信息中不得出现违法和不良信息，未经他人许可不得用他人名义（包括但不限于冒用他人姓名、名称、字号、头像等或采取其他足以让人引起混淆的方式）开设帐号，不得恶意注册</span
          ><span style="font-family:Helvetica; font-weight:bold; color:#444444">“咔嚓”</span
          ><span style="font-family:宋体; font-weight:bold; color:#444444"
            >帐号（包括但不限于频繁注册、批量注册帐号等行为）。您在帐号注册及使用过程中需遵守相关法律法规，不得实施任何侵害国家利益、损害其他公民合法权益，有害社会道德风尚的行为。我们有权对您提交的注册信息进行审核。</span
          >
        </p>
      </div>
      <div style="margin-top:12pt; margin-left:18pt; margin-bottom:12pt; background-color:#ffffff">
        <p
          style="margin-top:0pt; margin-left:22.5pt; margin-bottom:0pt; text-indent:-22.5pt; text-align:left; widows:2; orphans:2; font-size:12pt; -aw-import:list-item; -aw-list-level-number:1; -aw-list-number-format:'%0.%1'; -aw-list-number-styles:'decimal decimal'; -aw-list-number-values:'3 4'; -aw-list-padding-sml:7.5pt"
        >
          <span style="-aw-import:ignore"
            ><span style="font-family:Helvetica; color:#444444">3.4</span
            ><span
              style="width:7.5pt; font:7pt 'Times New Roman'; display:inline-block; -aw-import:spaces"
              >&nbsp;&nbsp;&nbsp;&nbsp;
            </span></span
          ><span style="font-family:宋体; color:#444444">您在</span
          ><span style="font-family:Helvetica; color:#444444">“咔嚓”</span
          ><span style="font-family:宋体; color:#444444"
            >中的注册帐号仅限于您本人使用，禁止以任何形式赠与、借用、出租、转让、售卖或以其他方式许可他人使用该帐号。如果我们发现或者有合理理由认为使用者并非帐号初始注册人，为保障帐号安全，我们有权立即暂停或终止向该注册帐号提供服务，并有权永久禁用该帐号。</span
          >
        </p>
      </div>
      <div style="margin-top:12pt; margin-left:18pt; margin-bottom:12pt; background-color:#ffffff">
        <p
          style="margin-top:0pt; margin-left:22.5pt; margin-bottom:0pt; text-indent:-22.5pt; text-align:left; widows:2; orphans:2; font-size:12pt; -aw-import:list-item; -aw-list-level-number:1; -aw-list-number-format:'%0.%1'; -aw-list-number-styles:'decimal decimal'; -aw-list-number-values:'3 5'; -aw-list-padding-sml:7.5pt"
        >
          <span style="-aw-import:ignore"
            ><span style="font-family:Helvetica; color:#444444">3.5</span
            ><span
              style="width:7.5pt; font:7pt 'Times New Roman'; display:inline-block; -aw-import:spaces"
              >&nbsp;&nbsp;&nbsp;&nbsp;
            </span></span
          >您有责任维护个人帐号、密码的安全性与保密性，并对您以注册帐号名义所从事的活动承担全部法律责任，包括但不限于您在“咔嚓”软件及相关服务上进行的任何数据修改、言论发表等操作行为可能引起的一切法律责任。您应高度重视对帐号与密码的保密，在任何情况下不向他人透露帐号及密码。若发现他人未经许可使用您的帐号或发生其他任何安全漏洞问题时，您应当立即通知我们。
        </p>
      </div>
      <div style="margin-top:12pt; margin-left:18pt; margin-bottom:12pt; background-color:#ffffff">
        <p
          style="margin-top:0pt; margin-left:22.5pt; margin-bottom:0pt; text-indent:-22.5pt; text-align:left; widows:2; orphans:2; font-size:12pt; -aw-import:list-item; -aw-list-level-number:1; -aw-list-number-format:'%0.%1'; -aw-list-number-styles:'decimal decimal'; -aw-list-number-values:'3 6'; -aw-list-padding-sml:7.5pt"
        >
          3.6
          当您完成“咔嚓”的帐号注册、登录后，您可随时浏览、修改自己提交的个人身份信息。您理解并同意，出于安全性您也可以按第3.2条的约定申请注销帐号，我们会依照您的要求删除有关您帐号的一切信息，法律法规另有规定的除外。
        </p>
      </div>
      <ol start="4" type="1" style="margin:0pt; padding-left:0pt">
        <li
          style="margin-top:12pt;  margin-bottom:12pt; text-align:left; widows:2; orphans:2;  font-family:Helvetica; font-size:12pt; font-weight:bold; color:#444444; background-color:#ffffff"
        >
          <span style="font-family:宋体">4. 您的必要授权</span>
          <ol type="1" class="awlist2" style="margin-right:0pt; margin-left:0pt; padding-left:0pt">
            <li
              style="margin-top:12pt; margin-left:22.5pt; margin-bottom:12pt; text-indent:-22.5pt; font-weight:normal; background-color:#ffffff; -aw-list-padding-sml:7.5pt"
            >
              <span
                style="width:7.5pt; font:7pt 'Times New Roman'; display:inline-block; -aw-import:ignore"
                >&nbsp;&nbsp;&nbsp;&nbsp; </span
              ><span style="font-family:宋体">4.1 在您使用</span><span>“咔嚓”</span
              ><span style="font-family:宋体"
                >提供的服务时需要提供一些必要的授权，例如：您需要通过手机号码注册帐号，同意并授权我们将您在</span
              ><span>“咔嚓”</span
              ><span style="font-family:宋体">上发布的内容（定义详见本协议第</span><span>5</span
              ><span style="font-family:宋体">条），包括但不限于将您在</span><span>“咔嚓”</span
              ><span style="font-family:宋体">上</span><span>“咔嚓”</span
              ><span style="font-family:宋体"
                >发布的图片、视频、文字、展示的地址位置等内容通过信息网络传播、展示给其他用户。</span
              >
            </li>
            <li
              style="margin-top:12pt; margin-left:22.5pt; margin-bottom:12pt; text-indent:-22.5pt; font-weight:normal; background-color:#ffffff; -aw-list-padding-sml:7.5pt"
            >
              <span
                style="width:7.5pt; font:7pt 'Times New Roman'; display:inline-block; -aw-import:ignore"
              >
              </span
              ><span style="font-family:宋体">4.2 在您权益受到侵犯并且导致</span><span>“咔嚓”</span
              ><span style="font-family:宋体">权益受损情况下，与</span><span>“咔嚓”</span
              ><span style="font-family:宋体">作为一致行动人，授予</span><span>“咔嚓”</span
              ><span style="font-family:宋体"
                >代表您，针对进行该侵犯行为的任何第三方，提出警告、投诉、发起或参与行政执法程序或民事、刑事司法程序，或谈判和解，并且您同意在</span
              ><span>“咔嚓”</span
              ><span style="font-family:宋体">认为必要的情况下共同参与该维权行动。</span>
            </li>
          </ol>
        </li>
        <li
          style="margin-top:12pt;  margin-bottom:12pt; text-align:left; widows:2; orphans:2;  font-family:Helvetica; font-size:12pt; font-weight:bold; color:#444444; background-color:#ffffff"
        >
          <span style="font-family:宋体">5. 内容发布规范</span>
          <ol type="1" class="awlist3" style="margin-right:0pt; margin-left:0pt; padding-left:0pt">
            <li
              style="margin-top:12pt; margin-left:22.5pt; margin-bottom:12pt; text-indent:-22.5pt; font-weight:normal; background-color:#ffffff; -aw-list-padding-sml:7.5pt"
            >
              <span
                style="width:7.5pt; font:7pt 'Times New Roman'; display:inline-block; -aw-import:ignore"
              ></span
              ><span style="font-family:宋体">5.1 “</span><span>咔嚓</span
              ><span style="font-family:宋体"
                >”致力使发布信息、互动交流、评论成为文明、理性、友善、高质量的意见交流。在推动发布信息、互动交流、评论业务发展的同时，不断加强相应的信息安全管理能力，完善发布信息、互动交流、评论自律，切实履行社会责任，遵守国家法律法规，尊重公民合法权益，尊重社会公序良俗。</span
              >
            </li>
            <li
              style="margin-top:12pt; margin-left:22.5pt; margin-bottom:12pt; text-indent:-22.5pt; font-weight:normal; background-color:#ffffff; -aw-list-padding-sml:7.5pt"
            >
              <span
                style="width:7.5pt; font:7pt 'Times New Roman'; display:inline-block; -aw-import:ignore"
              ></span
              ><span style="font-family:宋体">5.2 您应对使用</span><span>“咔嚓”</span
              ><span style="font-family:宋体"
                >发布的内容的真实性、合法性负责。本协议所述内容是指您使用本软件及服务过程中所制作、复制、发布、传播的任何内容，包括但不限于</span
              ><span>“咔嚓”</span
              ><span style="font-family:宋体"
                >帐号的头像、昵称、用户说明、简介等个人信息，或发送的文字、语音、图片、视频、表情等信息、评论、相关链接页面
                ，以及其他使用本软件及服务所产生的内容。您同意严格遵守相关法律法规、社会主义制度、国家利益、公民合法权益、社会公共秩序、道德风尚和信息真实性等“七条底线”要求以及遵守</span
              ><span>“咔嚓”</span
              ><span style="font-family:宋体"
                >平台相关规则，否则公司有权立即采取相应处理措施。您同意并承诺不得直接或间接发布如下法律、法规和政策禁止的信息：</span
              >
            </li>
          </ol>
        </li>
      </ol>
      <div style="margin-left:40.5pt; background-color:#ffffff">
        <p
          style="margin-top:0pt; margin-left:20pt; margin-bottom:0pt; text-indent:-36pt; text-align:left; widows:2; orphans:2; font-size:12pt; -aw-import:list-item; -aw-list-level-number:0; -aw-list-number-format:'（%0）'; -aw-list-number-styles:'decimal'; -aw-list-number-values:'1'; -aw-list-padding-sml:11.33pt"
        >
          <span style="-aw-import:ignore"
            ><span style="font-family:宋体; color:#444444">（</span
            ><span style="font-family:Helvetica; color:#444444">1</span
            ><span style="font-family:宋体; color:#444444">）</span
            ><span
              style="width:11.33pt; font:7pt 'Times New Roman'; display:inline-block; -aw-import:spaces"
              >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </span></span
          ><span style="font-family:宋体; color:#444444">反对宪法确定的基本原则的；</span>
        </p>
      </div>
      <div style="margin-left:40.5pt; background-color:#ffffff">
        <p
          style="margin-top:0pt; margin-left:20pt; margin-bottom:0pt; text-indent:-36pt; text-align:left; widows:2; orphans:2; font-size:12pt; -aw-import:list-item; -aw-list-level-number:0; -aw-list-number-format:'（%0）'; -aw-list-number-styles:'decimal'; -aw-list-number-values:'2'; -aw-list-padding-sml:11.33pt"
        >
          <span style="-aw-import:ignore"
            ><span style="font-family:宋体; color:#444444">（</span
            ><span style="font-family:Helvetica; color:#444444">2</span
            ><span style="font-family:宋体; color:#444444">）</span
            ><span
              style="width:11.33pt; font:7pt 'Times New Roman'; display:inline-block; -aw-import:spaces"
              >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </span></span
          ><span style="font-family:宋体; color:#444444">危害国家安全，泄露国家秘密的；</span>
        </p>
      </div>
      <div style="margin-left:40.5pt; background-color:#ffffff">
        <p
          style="margin-top:0pt; margin-left:20pt; margin-bottom:0pt; text-indent:-36pt; text-align:left; widows:2; orphans:2; font-size:12pt; -aw-import:list-item; -aw-list-level-number:0; -aw-list-number-format:'（%0）'; -aw-list-number-styles:'decimal'; -aw-list-number-values:'3'; -aw-list-padding-sml:11.33pt"
        >
          <span style="-aw-import:ignore"
            ><span style="font-family:宋体; color:#444444">（</span
            ><span style="font-family:Helvetica; color:#444444">3</span
            ><span style="font-family:宋体; color:#444444">）</span
            ><span
              style="width:11.33pt; font:7pt 'Times New Roman'; display:inline-block; -aw-import:spaces"
              >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </span></span
          ><span style="font-family:宋体; color:#444444"
            >颠覆国家政权，推翻社会主义制度，煽动分裂国家，破坏国家统一的；</span
          >
        </p>
      </div>
      <div style="margin-left:40.5pt; background-color:#ffffff">
        <p
          style="margin-top:0pt; margin-left:20pt; margin-bottom:0pt; text-indent:-36pt; text-align:left; widows:2; orphans:2; font-size:12pt; -aw-import:list-item; -aw-list-level-number:0; -aw-list-number-format:'（%0）'; -aw-list-number-styles:'decimal'; -aw-list-number-values:'4'; -aw-list-padding-sml:11.33pt"
        >
          <span style="-aw-import:ignore"
            ><span style="font-family:宋体; color:#444444">（</span
            ><span style="font-family:Helvetica; color:#444444">4</span
            ><span style="font-family:宋体; color:#444444">）</span
            ><span
              style="width:11.33pt; font:7pt 'Times New Roman'; display:inline-block; -aw-import:spaces"
              >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </span></span
          ><span style="font-family:宋体; color:#444444">损害国家荣誉和利益的；</span>
        </p>
      </div>
      <div style="margin-left:40.5pt; background-color:#ffffff">
        <p
          style="margin-top:0pt; margin-left:20pt; margin-bottom:0pt; text-indent:-36pt; text-align:left; widows:2; orphans:2; font-size:12pt; -aw-import:list-item; -aw-list-level-number:0; -aw-list-number-format:'（%0）'; -aw-list-number-styles:'decimal'; -aw-list-number-values:'5'; -aw-list-padding-sml:11.33pt"
        >
          <span style="-aw-import:ignore"
            ><span style="font-family:宋体; color:#444444">（</span
            ><span style="font-family:Helvetica; color:#444444">5</span
            ><span style="font-family:宋体; color:#444444">）</span
            ><span
              style="width:11.33pt; font:7pt 'Times New Roman'; display:inline-block; -aw-import:spaces"
              >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </span></span
          ><span style="font-family:宋体; color:#444444">宣扬恐怖主义、极端主义的；</span>
        </p>
      </div>
      <div style="margin-left:40.5pt; background-color:#ffffff">
        <p
          style="margin-top:0pt; margin-left:20pt; margin-bottom:0pt; text-indent:-36pt; text-align:left; widows:2; orphans:2; font-size:12pt; -aw-import:list-item; -aw-list-level-number:0; -aw-list-number-format:'（%0）'; -aw-list-number-styles:'decimal'; -aw-list-number-values:'6'; -aw-list-padding-sml:11.33pt"
        >
          <span style="-aw-import:ignore"
            ><span style="font-family:宋体; color:#444444">（</span
            ><span style="font-family:Helvetica; color:#444444">6</span
            ><span style="font-family:宋体; color:#444444">）</span
            ><span
              style="width:11.33pt; font:7pt 'Times New Roman'; display:inline-block; -aw-import:spaces"
              >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </span></span
          ><span style="font-family:宋体; color:#444444"
            >宣扬民族仇恨、民族歧视，破坏民族团结的；</span
          >
        </p>
      </div>
      <div style="margin-left:40.5pt; background-color:#ffffff">
        <p
          style="margin-top:0pt; margin-left:20pt; margin-bottom:0pt; text-indent:-36pt; text-align:left; widows:2; orphans:2; font-size:12pt; -aw-import:list-item; -aw-list-level-number:0; -aw-list-number-format:'（%0）'; -aw-list-number-styles:'decimal'; -aw-list-number-values:'7'; -aw-list-padding-sml:11.33pt"
        >
          <span style="-aw-import:ignore"
            ><span style="font-family:宋体; color:#444444">（</span
            ><span style="font-family:Helvetica; color:#444444">7</span
            ><span style="font-family:宋体; color:#444444">）</span
            ><span
              style="width:11.33pt; font:7pt 'Times New Roman'; display:inline-block; -aw-import:spaces"
              >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </span></span
          ><span style="font-family:宋体; color:#444444">煽动地域歧视、地域仇恨的；</span>
        </p>
      </div>
      <div style="margin-left:40.5pt; background-color:#ffffff">
        <p
          style="margin-top:0pt; margin-left:20pt; margin-bottom:0pt; text-indent:-36pt; text-align:left; widows:2; orphans:2; font-size:12pt; -aw-import:list-item; -aw-list-level-number:0; -aw-list-number-format:'（%0）'; -aw-list-number-styles:'decimal'; -aw-list-number-values:'8'; -aw-list-padding-sml:11.33pt"
        >
          <span style="-aw-import:ignore"
            ><span style="font-family:宋体; color:#444444">（</span
            ><span style="font-family:Helvetica; color:#444444">8</span
            ><span style="font-family:宋体; color:#444444">）</span
            ><span
              style="width:11.33pt; font:7pt 'Times New Roman'; display:inline-block; -aw-import:spaces"
              >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </span></span
          ><span style="font-family:宋体; color:#444444"
            >破坏国家宗教政策，宣扬邪教和封建迷信的；</span
          >
        </p>
      </div>
      <div style="margin-left:40.5pt; background-color:#ffffff">
        <p
          style="margin-top:0pt; margin-left:20pt; margin-bottom:0pt; text-indent:-36pt; text-align:left; widows:2; orphans:2; font-size:12pt; -aw-import:list-item; -aw-list-level-number:0; -aw-list-number-format:'（%0）'; -aw-list-number-styles:'decimal'; -aw-list-number-values:'9'; -aw-list-padding-sml:11.33pt"
        >
          <span style="-aw-import:ignore"
            ><span style="font-family:宋体; color:#444444">（</span
            ><span style="font-family:Helvetica; color:#444444">9</span
            ><span style="font-family:宋体; color:#444444">）</span
            ><span
              style="width:11.33pt; font:7pt 'Times New Roman'; display:inline-block; -aw-import:spaces"
              >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </span></span
          ><span style="font-family:宋体; color:#444444"
            >编造、散布谣言、虚假信息，扰乱经济秩序和社会秩序、破坏社会稳定的；</span
          >
        </p>
      </div>
      <div style="margin-left:40.5pt; background-color:#ffffff">
        <p
          style="margin-top:0pt; margin-left:20pt; margin-bottom:0pt; text-indent:-36pt; text-align:left; widows:2; orphans:2; font-size:12pt; -aw-import:list-item; -aw-list-level-number:0; -aw-list-number-format:'（%0）'; -aw-list-number-styles:'decimal'; -aw-list-number-values:'10'; -aw-list-padding-sml:5.33pt"
        >
          <span style="-aw-import:ignore"
            ><span style="font-family:宋体; color:#444444">（</span
            ><span style="font-family:Helvetica; color:#444444">10</span
            ><span style="font-family:宋体; color:#444444">）</span
            ><span
              style="width:5.33pt; font:7pt 'Times New Roman'; display:inline-block; -aw-import:spaces"
              >&nbsp;&nbsp;&nbsp;
            </span></span
          ><span style="font-family:宋体; color:#444444"
            >散布、传播淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</span
          >
        </p>
      </div>
      <div style="margin-left:40.5pt; background-color:#ffffff">
        <p
          style="margin-top:0pt; margin-left:20pt; margin-bottom:0pt; text-indent:-36pt; text-align:left; widows:2; orphans:2; font-size:12pt; -aw-import:list-item; -aw-list-level-number:0; -aw-list-number-format:'（%0）'; -aw-list-number-styles:'decimal'; -aw-list-number-values:'11'; -aw-list-padding-sml:5.33pt"
        >
          <span style="-aw-import:ignore"
            ><span style="font-family:宋体; color:#444444">（</span
            ><span style="font-family:Helvetica; color:#444444">11</span
            ><span style="font-family:宋体; color:#444444">）</span
            ><span
              style="width:5.33pt; font:7pt 'Times New Roman'; display:inline-block; -aw-import:spaces"
              >&nbsp;&nbsp;&nbsp;
            </span></span
          ><span style="font-family:宋体; color:#444444"
            >煽动非法集会、结社、游行、示威、聚众扰乱社会秩序的；</span
          >
        </p>
      </div>
      <div style="margin-left:40.5pt; background-color:#ffffff">
        <p
          style="margin-top:0pt; margin-left:20pt; margin-bottom:0pt; text-indent:-36pt; text-align:left; widows:2; orphans:2; font-size:12pt; -aw-import:list-item; -aw-list-level-number:0; -aw-list-number-format:'（%0）'; -aw-list-number-styles:'decimal'; -aw-list-number-values:'12'; -aw-list-padding-sml:5.33pt"
        >
          <span style="-aw-import:ignore"
            ><span style="font-family:宋体; color:#444444">（</span
            ><span style="font-family:Helvetica; color:#444444">12</span
            ><span style="font-family:宋体; color:#444444">）</span
            ><span
              style="width:5.33pt; font:7pt 'Times New Roman'; display:inline-block; -aw-import:spaces"
              >&nbsp;&nbsp;&nbsp;
            </span></span
          ><span style="font-family:宋体; color:#444444"
            >危害网络安全、利用网络从事危害国家安全、荣誉和利益的；</span
          >
        </p>
      </div>
      <div style="margin-left:40.5pt; background-color:#ffffff">
        <p
          style="margin-top:0pt; margin-left:20pt; margin-bottom:0pt; text-indent:-36pt; text-align:left; widows:2; orphans:2; font-size:12pt; -aw-import:list-item; -aw-list-level-number:0; -aw-list-number-format:'（%0）'; -aw-list-number-styles:'decimal'; -aw-list-number-values:'13'; -aw-list-padding-sml:5.33pt"
        >
          <span style="-aw-import:ignore"
            ><span style="font-family:宋体; color:#444444">（</span
            ><span style="font-family:Helvetica; color:#444444">13</span
            ><span style="font-family:宋体; color:#444444">）</span
            ><span
              style="width:5.33pt; font:7pt 'Times New Roman'; display:inline-block; -aw-import:spaces"
              >&nbsp;&nbsp;&nbsp;
            </span></span
          ><span style="font-family:宋体; color:#444444"
            >侮辱或者诽谤他人，侵害他人合法权益的；</span
          >
        </p>
      </div>
      <div style="margin-left:40.5pt; background-color:#ffffff">
        <p
          style="margin-top:0pt; margin-left:20pt; margin-bottom:0pt; text-indent:-36pt; text-align:left; widows:2; orphans:2; font-size:12pt; -aw-import:list-item; -aw-list-level-number:0; -aw-list-number-format:'（%0）'; -aw-list-number-styles:'decimal'; -aw-list-number-values:'14'; -aw-list-padding-sml:5.33pt"
        >
          <span style="-aw-import:ignore"
            ><span style="font-family:宋体; color:#444444">（</span
            ><span style="font-family:Helvetica; color:#444444">14</span
            ><span style="font-family:宋体; color:#444444">）</span
            ><span
              style="width:5.33pt; font:7pt 'Times New Roman'; display:inline-block; -aw-import:spaces"
              >&nbsp;&nbsp;&nbsp;
            </span></span
          ><span style="font-family:宋体; color:#444444"
            >对他人进行暴力恐吓、威胁，实施人肉搜索的；</span
          >
        </p>
      </div>
      <div style="margin-left:40.5pt; background-color:#ffffff">
        <p
          style="margin-top:0pt; margin-left:20pt; margin-bottom:0pt; text-indent:-36pt; text-align:left; widows:2; orphans:2; font-size:12pt; -aw-import:list-item; -aw-list-level-number:0; -aw-list-number-format:'（%0）'; -aw-list-number-styles:'decimal'; -aw-list-number-values:'15'; -aw-list-padding-sml:5.33pt"
        >
          <span style="-aw-import:ignore"
            ><span style="font-family:宋体; color:#444444">（</span
            ><span style="font-family:Helvetica; color:#444444">15</span
            ><span style="font-family:宋体; color:#444444">）</span
            ><span
              style="width:5.33pt; font:7pt 'Times New Roman'; display:inline-block; -aw-import:spaces"
              >&nbsp;&nbsp;&nbsp;
            </span></span
          ><span style="font-family:宋体; color:#444444">涉及他人隐私、个人信息或资料的；</span>
        </p>
      </div>
      <div style="margin-left:40.5pt; background-color:#ffffff">
        <p
          style="margin-top:0pt; margin-left:20pt; margin-bottom:0pt; text-indent:-36pt; text-align:left; widows:2; orphans:2; font-size:12pt; -aw-import:list-item; -aw-list-level-number:0; -aw-list-number-format:'（%0）'; -aw-list-number-styles:'decimal'; -aw-list-number-values:'16'; -aw-list-padding-sml:5.33pt"
        >
          <span style="-aw-import:ignore"
            ><span style="font-family:宋体; color:#444444">（</span
            ><span style="font-family:Helvetica; color:#444444">16</span
            ><span style="font-family:宋体; color:#444444">）</span
            ><span
              style="width:5.33pt; font:7pt 'Times New Roman'; display:inline-block; -aw-import:spaces"
              >&nbsp;&nbsp;&nbsp;
            </span></span
          ><span style="font-family:宋体; color:#444444">散布污言秽语，损害社会公序良俗的；</span>
        </p>
      </div>
      <div style="margin-left:40.5pt; background-color:#ffffff">
        <p
          style="margin-top:0pt; margin-left:20pt; margin-bottom:0pt; text-indent:-36pt; text-align:left; widows:2; orphans:2; font-size:12pt; -aw-import:list-item; -aw-list-level-number:0; -aw-list-number-format:'（%0）'; -aw-list-number-styles:'decimal'; -aw-list-number-values:'17'; -aw-list-padding-sml:5.33pt"
        >
          <span style="-aw-import:ignore"
            ><span style="font-family:宋体; color:#444444">（</span
            ><span style="font-family:Helvetica; color:#444444">17</span
            ><span style="font-family:宋体; color:#444444">）</span
            ><span
              style="width:5.33pt; font:7pt 'Times New Roman'; display:inline-block; -aw-import:spaces"
              >&nbsp;&nbsp;&nbsp;
            </span></span
          ><span style="font-family:宋体; color:#444444"
            >侵犯他人隐私权、名誉权、肖像权、知识产权、商业秘密等合法权益内容的；</span
          >
        </p>
      </div>
      <p
        style="margin-top:0pt; margin-left:59pt; margin-bottom:0pt; text-indent:-36pt; font-size:12pt; -aw-import:list-item; -aw-list-level-number:0; -aw-list-number-format:'（%0）'; -aw-list-number-styles:'decimal'; -aw-list-number-values:'18'; -aw-list-padding-sml:5.33pt"
      >
        <span style="-aw-import:ignore"
          ><span style="font-family:宋体; color:#444444">（</span
          ><span style="font-family:Helvetica; color:#444444">18</span
          ><span style="font-family:宋体; color:#444444">）</span
          ><span
            style="width:5.33pt; font:7pt 'Times New Roman'; display:inline-block; -aw-import:spaces"
            >&nbsp;&nbsp;&nbsp;
          </span></span
        ><span style="font-family:宋体; color:#444444"
          >不正当竞争信息，其表现可能包括但不限于发布篡改、增减、删除权利标识的内容；发布未经授权方授权的内容等。</span
        >
      </p>
      <div style="margin-left:40.5pt; background-color:#ffffff">
        <p
          style="margin-top:0pt; margin-left:20pt; margin-bottom:0pt; text-indent:-36pt; text-align:left; widows:2; orphans:2; font-size:12pt; -aw-import:list-item; -aw-list-level-number:0; -aw-list-number-format:'（%0）'; -aw-list-number-styles:'decimal'; -aw-list-number-values:'19'; -aw-list-padding-sml:5.33pt"
        >
          <span style="-aw-import:ignore"
            ><span style="font-family:宋体; color:#444444">（</span
            ><span style="font-family:Helvetica; color:#444444">19</span
            ><span style="font-family:宋体; color:#444444">）</span
            ><span
              style="width:5.33pt; font:7pt 'Times New Roman'; display:inline-block; -aw-import:spaces"
              >&nbsp;&nbsp;&nbsp;
            </span></span
          ><span style="font-family:宋体; color:#444444"
            >散布商业广告，或类似的商业招揽信息、过度营销信息及垃圾信息；</span
          >
        </p>
      </div>
      <div style="margin-left:40.5pt; background-color:#ffffff">
        <p
          style="margin-top:0pt; margin-left:20pt; margin-bottom:0pt; text-indent:-36pt; text-align:left; widows:2; orphans:2; font-size:12pt; -aw-import:list-item; -aw-list-level-number:0; -aw-list-number-format:'（%0）'; -aw-list-number-styles:'decimal'; -aw-list-number-values:'20'; -aw-list-padding-sml:5.33pt"
        >
          <span style="-aw-import:ignore"
            ><span style="font-family:宋体; color:#444444">（</span
            ><span style="font-family:Helvetica; color:#444444">20</span
            ><span style="font-family:宋体; color:#444444">）</span
            ><span
              style="width:5.33pt; font:7pt 'Times New Roman'; display:inline-block; -aw-import:spaces"
              >&nbsp;&nbsp;&nbsp;
            </span></span
          ><span style="font-family:宋体; color:#444444"
            >所发表的信息毫无意义的，或刻意使用字符组合以逃避技术审核的；</span
          >
        </p>
      </div>
      <div style="margin-left:40.5pt; background-color:#ffffff">
        <p
          style="margin-top:0pt; margin-left:20pt; margin-bottom:0pt; text-indent:-36pt; text-align:left; widows:2; orphans:2; font-size:12pt; -aw-import:list-item; -aw-list-level-number:0; -aw-list-number-format:'（%0）'; -aw-list-number-styles:'decimal'; -aw-list-number-values:'21'; -aw-list-padding-sml:5.33pt"
        >
          <span style="-aw-import:ignore"
            ><span style="font-family:宋体; color:#444444">（</span
            ><span style="font-family:Helvetica; color:#444444">21</span
            ><span style="font-family:宋体; color:#444444">）</span
            ><span
              style="width:5.33pt; font:7pt 'Times New Roman'; display:inline-block; -aw-import:spaces"
              >&nbsp;&nbsp;&nbsp;
            </span></span
          ><span style="font-family:宋体; color:#444444"
            >侵害未成年人合法权益或者损害未成年人身心健康的；</span
          >
        </p>
      </div>
      <div style="margin-left:40.5pt; background-color:#ffffff">
        <p
          style="margin-top:0pt; margin-left:20pt; margin-bottom:0pt; text-indent:-36pt; text-align:left; widows:2; orphans:2; font-size:12pt; -aw-import:list-item; -aw-list-level-number:0; -aw-list-number-format:'（%0）'; -aw-list-number-styles:'decimal'; -aw-list-number-values:'22'; -aw-list-padding-sml:5.33pt"
        >
          <span style="-aw-import:ignore"
            ><span style="font-family:宋体; color:#444444">（</span
            ><span style="font-family:Helvetica; color:#444444">22</span
            ><span style="font-family:宋体; color:#444444">）</span
            ><span
              style="width:5.33pt; font:7pt 'Times New Roman'; display:inline-block; -aw-import:spaces"
              >&nbsp;&nbsp;&nbsp;
            </span></span
          ><span style="font-family:宋体; color:#444444"
            >未获他人允许，偷拍、偷录他人，侵害他人合法权利的；</span
          >
        </p>
      </div>
      <p
        style="margin-top:0pt; margin-left:59pt; margin-bottom:0pt; text-indent:-36pt; font-size:12pt; -aw-import:list-item; -aw-list-level-number:0; -aw-list-number-format:'（%0）'; -aw-list-number-styles:'decimal'; -aw-list-number-values:'23'; -aw-list-padding-sml:5.33pt"
      >
        <span style="-aw-import:ignore"
          ><span style="font-family:宋体; color:#444444">（</span
          ><span style="font-family:Helvetica; color:#444444">23</span
          ><span style="font-family:宋体; color:#444444">）</span
          ><span
            style="width:5.33pt; font:7pt 'Times New Roman'; display:inline-block; -aw-import:spaces"
            >&nbsp;&nbsp;&nbsp;
          </span></span
        ><span style="font-family:宋体; color:#444444">虚假广告、虚假中奖信息等欺诈信息；</span>
      </p>
      <div style="margin-left:40.5pt; margin-bottom:14pt; background-color:#ffffff">
        <p
          style="margin-top:0pt; margin-left:20pt; margin-bottom:0pt; text-indent:-36pt; text-align:left; widows:2; orphans:2; font-size:12pt; -aw-import:list-item; -aw-list-level-number:0; -aw-list-number-format:'（%0）'; -aw-list-number-styles:'decimal'; -aw-list-number-values:'24'; -aw-list-padding-sml:5.33pt"
        >
          <span style="-aw-import:ignore"
            ><span style="font-family:宋体; color:#444444">（</span
            ><span style="font-family:Helvetica; color:#444444">24</span
            ><span style="font-family:宋体; color:#444444">）</span
            ><span
              style="width:5.33pt; font:7pt 'Times New Roman'; display:inline-block; -aw-import:spaces"
              >&nbsp;&nbsp;&nbsp;
            </span></span
          ><span style="font-family:宋体; color:#444444"
            >包含恐怖、暴力血腥、高危险性、危害表演者自身或他人身心健康内容的，包括但不限于以下情形：</span
          >
        </p>
      </div>
      <p
        style="margin-top:14pt; margin-left:59pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:12pt; background-color:#ffffff"
      >
        <span style="font-family:Helvetica; color:#444444">i. </span
        ><span style="font-family:宋体; color:#444444">任何暴力和</span
        ><span style="font-family:Helvetica; color:#444444">/</span
        ><span style="font-family:宋体; color:#444444">或自残行为内容；</span>
      </p>
      <p
        style="margin-top:14pt; margin-left:59pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:12pt; background-color:#ffffff"
      >
        <span style="font-family:Helvetica; color:#444444">ii. </span
        ><span style="font-family:宋体; color:#444444"
          >任何威胁生命健康、利用刀具等危险器械表演的危及自身或他人人身及</span
        ><span style="font-family:Helvetica; color:#444444">/</span
        ><span style="font-family:宋体; color:#444444">或财产权利的内容；</span>
      </p>
      <p
        style="margin-top:14pt; margin-left:59pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:12pt; background-color:#ffffff"
      >
        <span style="font-family:Helvetica; color:#444444">iii.</span
        ><span style="font-family:宋体; color:#444444"
          >怂恿、诱导他人参与可能会造成人身伤害或导致死亡的危险或违法活动的内容；</span
        >
      </p>
      <div style="margin-top:14pt; margin-left:40.5pt; background-color:#ffffff">
        <p
          style="margin-top:0pt; margin-left:20pt; margin-bottom:0pt; text-indent:-36pt; text-align:left; widows:2; orphans:2; font-size:12pt; -aw-import:list-item; -aw-list-level-number:0; -aw-list-number-format:'（%0）'; -aw-list-number-styles:'decimal'; -aw-list-number-values:'25'; -aw-list-padding-sml:5.33pt"
        >
          <span style="-aw-import:ignore"
            ><span style="font-family:宋体; color:#444444">（</span
            ><span style="font-family:Helvetica; color:#444444">25</span
            ><span style="font-family:宋体; color:#444444">）</span
            ><span
              style="width:5.33pt; font:7pt 'Times New Roman'; display:inline-block; -aw-import:spaces"
              >&nbsp;&nbsp;&nbsp;
            </span></span
          ><span style="font-family:宋体; color:#444444"
            >其他含有违反法律法规、政策及公序良俗、干扰</span
          ><span style="font-family:Helvetica; color:#444444">“咔嚓”</span
          ><span style="font-family:宋体; color:#444444"
            >正常运营或侵犯其他用户或第三方合法权益内容的信息。</span
          >
        </p>
      </div>
      <div style="margin-top:12pt; margin-left:18pt; margin-bottom:12pt; background-color:#ffffff">
        <p
          style="margin-top:0pt;margin-left:8pt;margin-bottom:0pt; text-indent:-22.5pt; text-align:left; widows:2; orphans:2; font-size:12pt; -aw-import:list-item; -aw-list-level-number:1; -aw-list-number-format:'%0.%1'; -aw-list-number-styles:'decimal decimal'; -aw-list-number-values:'5 3'; -aw-list-padding-sml:7.5pt"
        >
          <span style="-aw-import:ignore"
            ><span style="font-family:Helvetica; color:#444444">5.3</span
            ><span
              style="width:7.5pt; font:7pt 'Times New Roman'; display:inline-block; -aw-import:spaces"
              >&nbsp;&nbsp;&nbsp;&nbsp;
            </span></span
          ><span style="font-family:宋体; font-weight:bold">若您违反本协议和/或</span
          ><span style="font-family:Helvetica; color:#444444">“咔嚓”</span
          ><span style="font-family:宋体; font-weight:bold">平台的其他规则，您同意</span
          ><span style="font-family:Helvetica; color:#444444">“咔嚓”</span
          ><span style="font-family:宋体; font-weight:bold"
            >有权根据自身的判断或法律与政策的需要，自主决定并可在不预先通知您的情况下，全部或者部分地选择：（1）采取技术手段删除、屏蔽或断开相关用户内容的链接；（2）暂停或终止对您的软件使用许可并停止相应技术服务，采取包括但不限于限制、冻结或终止“咔嚓”帐号使用措施；（3）诉诸行政执法机构或者司法机关，以追究相应法律责任。</span
          >
        </p>
      </div>
      <div style="margin-top:12pt; margin-left:18pt; margin-bottom:12pt; background-color:#ffffff">
        <p
          style="margin-top:0pt; margin-left:8pt; margin-bottom:0pt; text-indent:-22.5pt; text-align:left; widows:2; orphans:2; font-size:12pt; -aw-import:list-item; -aw-list-level-number:1; -aw-list-number-format:'%0.%1'; -aw-list-number-styles:'decimal decimal'; -aw-list-number-values:'5 4'; -aw-list-padding-sml:7.5pt"
        >
          <span style="-aw-import:ignore"
            ><span style="font-family:Helvetica; color:#444444">5.4</span
            ><span
              style="width:7.5pt; font:7pt 'Times New Roman'; display:inline-block; -aw-import:spaces"
              >&nbsp;&nbsp;&nbsp;&nbsp;
            </span></span
          ><span style="font-family:Helvetica; color:#444444">“咔嚓”</span
          ><span style="font-family:宋体; color:#444444"
            >设立公众投诉、举报平台，您可按照公司公示的投诉举报制度向公司投诉、举报各类违法违规行为、违法传播活动、违法有害信息等内容，公司将及时受理和处理您的投诉举报，以共同营造风清气正的网络空间。</span
          >
        </p>
      </div>
      <ol start="6" type="1" style="margin:0pt; padding-left:0pt">
        <li
          style="margin-top:12pt;  margin-bottom:12pt; text-align:left; widows:2; orphans:2;  font-family:Helvetica; font-size:12pt; font-weight:bold; color:#444444; background-color:#ffffff"
        >
          <span style="font-family:宋体">6. 违约处理</span>
          <ol type="1" class="awlist4" style="margin-right:0pt; margin-left:0pt; padding-left:0pt">
            <li
              style="margin-top:12pt; margin-left:22.5pt; margin-bottom:12pt; text-indent:-22.5pt; font-weight:normal; background-color:#ffffff; -aw-list-padding-sml:7.5pt"
            >
              <span
                style="width:7.5pt; font:7pt 'Times New Roman'; display:inline-block; -aw-import:ignore"
                >&nbsp;&nbsp;&nbsp;&nbsp; </span
              ><span style="font-family:宋体; font-weight:bold"
                >6.1
                针对您违反本协议或其他服务条款的行为，我们有权视情况采取预先警示、拒绝发布、立即停止传输信息、音频、视频、音视频等内容、短期禁止发言、限制帐号部分或者全部功能直至终止提供服务、永久关闭帐号等措施。</span
              ><span style="font-family:宋体"
                >我们有权公告处理结果，且有权根据实际情况决定是否恢复相关帐号的使用。对涉嫌违反法律法规、涉嫌违法犯罪的行为，我们将保存有关记录，并有权依法向有关主管部门报告、配合有关主管部门调查、向公安机关报案等。对已删除内容我们有权不予恢复。</span
              >
            </li>
            <li
              style="margin-top:12pt; margin-left:22.5pt; margin-bottom:12pt; text-indent:-22.5pt; font-weight:normal; background-color:#ffffff; -aw-list-padding-sml:7.5pt"
            >
              <span
                style="width:7.5pt; font:7pt 'Times New Roman'; display:inline-block; -aw-import:ignore"
                >&nbsp;&nbsp;&nbsp;&nbsp; </span
              ><span style="font-family:宋体; font-weight:bold"
                >6.2
                因您违反本协议或其他服务条款规定，引起第三方投诉或诉讼索赔的，您应当自行处理并承担可能因此产生的法律责任，包括但不限于赔偿</span
              ><span>“咔嚓”</span
              ><span style="font-family:宋体; font-weight:bold"
                >与合作公司、关联公司，并使之免受损害。</span
              >
            </li>
            <li
              style="margin-top:12pt; margin-left:22.5pt; margin-bottom:12pt; text-indent:-22.5pt; font-weight:normal; background-color:#ffffff; -aw-list-padding-sml:7.5pt"
            >
              <span
                style="width:7.5pt; font:7pt 'Times New Roman'; display:inline-block; -aw-import:ignore"
                >&nbsp;&nbsp;&nbsp;&nbsp; </span
              ><span>6.3 “咔嚓”</span
              ><span style="font-family:宋体"
                >尊重并保护用户及他人的知识产权、名誉权、姓名权、肖像权及隐私权等合法权益。您使用</span
              ><span>“咔嚓”</span
              ><span style="font-family:宋体"
                >软件及相关服务时上传的文字、图片、视频、照片、音频、链接等不应侵犯任何第三方的知识产权、名誉权、姓名权、肖像权、隐私权等权利及合法权益，否则，我们有权在收到权利方或者相关方通知的情况下移除该涉嫌侵权内容。针对第三方提出的全部权利主张，您应自行处理并承担可能因此产生的全部法律责任；如因您的侵权行为导致</span
              ><span>“咔嚓”</span
              ><span style="font-family:宋体"
                >及其关联方遭受损失的（包括但不限于经济、商誉等损失），您还应足额赔偿</span
              ><span>“咔嚓”</span><span style="font-family:宋体">及其关联方遭受的全部损失。</span>
            </li>
            <li
              style="margin-top:12pt; margin-left:22.5pt; margin-bottom:12pt; text-indent:-22.5pt; font-weight:normal; background-color:#ffffff; -aw-list-padding-sml:7.5pt"
            >
              <span
                style="width:7.5pt; font:7pt 'Times New Roman'; display:inline-block; -aw-import:ignore"
                >&nbsp;&nbsp;&nbsp;&nbsp; </span
              ><span style="font-family:宋体">6.4 除非</span><span>“咔嚓”</span
              ><span style="font-family:宋体">书面许可，您不得从事下列任一行为：</span>
            </li>
          </ol>
        </li>
      </ol>
      <p
        style="margin-top:12pt; margin-left:24pt; margin-bottom:12pt; text-align:left; widows:2; orphans:2; font-size:12pt; background-color:#ffffff"
      >
        <span style="font-family:Helvetica; color:#444444">(1) </span
        ><span style="font-family:宋体; color:#444444">删除软件副本上关于著作权的信息；</span>
      </p>
      <p
        style="margin-top:12pt; margin-left:24pt; margin-bottom:12pt; text-align:left; widows:2; orphans:2; font-size:12pt; background-color:#ffffff"
      >
        <span style="font-family:Helvetica; color:#444444">(2) </span
        ><span style="font-family:宋体; color:#444444"
          >对软件进行反向工程、反向汇编、反向编译，或者以其他方式尝试发现软件的源代码；</span
        >
      </p>
      <p
        style="margin-top:12pt; margin-left:24pt; margin-bottom:12pt; text-align:left; widows:2; orphans:2; font-size:12pt; background-color:#ffffff"
      >
        <span style="font-family:Helvetica; color:#444444">(3) </span
        ><span style="font-family:宋体; color:#444444">对</span
        ><span style="font-family:Helvetica; color:#444444">“咔嚓”</span
        ><span style="font-family:宋体; color:#444444"
          >及其关联公司拥有知识产权的内容进行使用、出租、出借、复制、修改、链接、转载、汇编、发表、出版、建立镜像站点等；</span
        >
      </p>
      <p
        style="margin-top:12pt; margin-left:24pt; margin-bottom:12pt; text-align:left; widows:2; orphans:2; font-size:12pt; background-color:#ffffff"
      >
        <span style="font-family:Helvetica; color:#444444">(4) </span
        ><span style="font-family:宋体; color:#444444"
          >对软件或者软件运行过程中释放到任何终端内存中的数据、软件运行过程中客户端与服务器端的交互数据，以及软件运行所必需的系统数据，进行复制、修改、增加、删除、挂接运行或创作任何衍生作品，形式包括但不限于使用插件、外挂或非经</span
        ><span style="font-family:Helvetica; color:#444444">“咔嚓”</span
        ><span style="font-family:宋体; color:#444444">及其授权的第三方工具</span
        ><span style="font-family:Helvetica; color:#444444">/</span
        ><span style="font-family:宋体; color:#444444">服务接入软件和相关系统；</span>
      </p>
      <p
        style="margin-top:12pt; margin-left:24pt; margin-bottom:12pt; text-align:left; widows:2; orphans:2; font-size:12pt; background-color:#ffffff"
      >
        <span style="font-family:Helvetica; color:#444444">(5) </span
        ><span style="font-family:宋体; color:#444444"
          >通过修改或伪造软件运行中的指令、数据，增加、删减、变动软件的功能或运行效果，或者将用于上述用途的软件、方法进行运营或向公众传播，无论这些行为是否为商业目的；</span
        >
      </p>
      <p
        style="margin-top:12pt; margin-left:24pt; margin-bottom:12pt; text-align:left; widows:2; orphans:2; font-size:12pt; background-color:#ffffff"
      >
        <span style="font-family:宋体; color:#444444">（</span
        ><span style="font-family:Helvetica; color:#444444">6) </span
        ><span style="font-family:宋体; color:#444444">通过非</span
        ><span style="font-family:Helvetica; color:#444444">“咔嚓”</span
        ><span style="font-family:宋体; color:#444444"
          >开发、授权的第三方软件、插件、外挂、系统，登录或使用</span
        ><span style="font-family:Helvetica; color:#444444">“咔嚓”</span
        ><span style="font-family:宋体; color:#444444">软件及服务，或制作、发布、传播非</span
        ><span style="font-family:Helvetica; color:#444444">“咔嚓”</span
        ><span style="font-family:宋体; color:#444444"
          >开发、授权的第三方软件、插件、外挂、系统。</span
        >
      </p>
      <ol start="7" type="1" style="margin:0pt; padding-left:0pt">
        <li
          style="margin-top:12pt;  margin-bottom:12pt; text-align:left; widows:2; orphans:2;  font-family:Helvetica; font-size:12pt; font-weight:bold; color:#444444; background-color:#ffffff"
        >
          <span style="font-family:宋体">7. 数据存储</span>
        </li>
      </ol>
      <p
        style="margin-top:12pt; margin-left:18pt; margin-bottom:12pt; text-align:left; widows:2; orphans:2; font-size:12pt; background-color:#ffffff"
      >
        <span style="font-family:Helvetica; font-weight:bold; color:#444444">“咔嚓”</span
        ><span style="font-family:宋体; font-weight:bold; color:#444444"
          >不对您在本服务中相关数据的删除或储存失败负责。在符合相关法律法规的前提下，</span
        ><span style="font-family:Helvetica; color:#444444">“咔嚓”</span
        ><span style="font-family:宋体; color:#444444"
          >将根据实际情况决定您在本服务中数据的最长储存期限。您可根据自己的需要自行备份本服务中的相关数据。</span
        ><span style="font-family:宋体; font-weight:bold; color:#444444">本服务停止、终止后，</span
        ><span style="font-family:Helvetica; font-weight:bold; color:#444444">“咔嚓”</span
        ><span style="font-family:宋体; font-weight:bold; color:#444444"
          >将依据法律法规的相关规定从服务器上永久地删除您的数据，在</span
        ><span style="font-family:Helvetica; font-weight:bold; color:#444444">“咔嚓”</span
        ><span style="font-family:宋体; font-weight:bold; color:#444444"
          >删除您的数据后，我们将无法向您返还任何数据。</span
        >
      </p>
      <ol start="8" type="1" style="margin:0pt; padding-left:0pt">
        <li
          style="margin-top:12pt;  margin-bottom:12pt; text-align:left; widows:2; orphans:2;  font-family:Helvetica; font-size:12pt; font-weight:bold; color:#444444; background-color:#ffffff"
        >
          <span style="font-family:宋体">8. 投诉举报处理</span>
        </li>
      </ol>
      <p
        style="margin-top:12pt; margin-left:18pt; margin-bottom:12pt; text-align:left; widows:2; orphans:2; font-size:12pt; background-color:#ffffff"
      >
        <span style="font-family:Helvetica; color:#444444">“咔嚓”</span
        ><span style="font-family:宋体; color:#444444">倡议您共同参与维护及监督</span
        ><span style="font-family:Helvetica; color:#444444">“咔嚓”</span
        ><span style="font-family:宋体; color:#444444">使用环境的合规与生态健康。无论是</span
        ><span style="font-family:Helvetica; color:#444444">“咔嚓”</span
        ><span style="font-family:宋体; color:#444444">主动发现用户的不当、违法行为，或者是</span
        ><span style="font-family:Helvetica; color:#444444">“咔嚓”</span
        ><span style="font-family:宋体; color:#444444"
          >根据举报、投诉并初步查实用户存在不当、违法行为，</span
        ><span style="font-family:Helvetica; color:#444444">“咔嚓”</span
        ><span style="font-family:宋体; color:#444444"
          >均有权立即在无事先通知的情况下采取必要的措施以制止该行为的继续进行。</span
        >
      </p>
      <ol start="9" type="1" style="margin:0pt; padding-left:0pt">
        <li
          style="margin-top:12pt;  margin-bottom:12pt; text-align:left; widows:2; orphans:2;  font-family:Helvetica; font-size:12pt; font-weight:bold; color:#444444; background-color:#ffffff"
        >
          <span style="font-family:宋体">9. 风险承担</span>
        </li>
      </ol>
      <p
        style="margin-top:12pt; margin-left:18pt; margin-bottom:12pt; text-align:left; widows:2; orphans:2; font-size:12pt; background-color:#ffffff"
      >
        <span style="font-family:Helvetica; font-weight:bold; color:#444444">“咔嚓”</span
        ><span style="font-family:宋体; font-weight:bold; color:#444444"
          >仅为用户提供内容发布、信息分享、传送及获取的平台，您必须为自己注册帐号下的行为负责，包括您所传送的内容以及由此产生的后果。您应对</span
        ><span style="font-family:Helvetica; font-weight:bold; color:#444444">“咔嚓”</span
        ><span style="font-family:宋体; font-weight:bold; color:#444444"
          >及本服务中的内容自行加以判断，并承担因使用内容而引起的风险，包括因对内容的正确性、完整性或实用性的依赖而产生的风险。因业务发展需要，</span
        ><span style="font-family:Helvetica; font-weight:bold; color:#444444">“咔嚓”</span
        ><span style="font-family:宋体; font-weight:bold; color:#444444"
          >有权对本服务的全部或部分服务内容变更、暂停、终止或撤销，您需承担此风险。</span
        >
      </p>
      <ol start="10" type="1" style="margin:0pt; padding-left:0pt">
        <li
          style="margin-top:12pt; margin-bottom:12pt; text-align:left; widows:2; orphans:2; font-family:Helvetica; font-size:12pt; font-weight:bold; color:#444444; background-color:#ffffff"
        >
          <span style="font-family:宋体">10. 法律责任</span>
        </li>
      </ol>
      <p
        style="margin-top:12pt; margin-left:18pt; margin-bottom:12pt; text-align:left; widows:2; orphans:2; font-size:12pt; background-color:#ffffff"
      >
        <span style="font-family:宋体; font-weight:bold; color:#444444">如果</span
        ><span style="font-family:Helvetica; font-weight:bold; color:#444444">“咔嚓”</span
        ><span style="font-family:宋体; font-weight:bold; color:#444444"
          >发现或收到他人举报或投诉您违反本协议约定的，</span
        ><span style="font-family:Helvetica; font-weight:bold; color:#444444">“咔嚓”</span
        ><span style="font-family:宋体; font-weight:bold; color:#444444"
          >有权对相关内容，包括但不限于对用户资料、发布内容进行审查、删除，并视情节轻重对违规帐号处以包括但不限于警告、帐号封禁
          、功能封禁的处罚，且通知您处理结果。</span
        ><span style="font-family:宋体; color:#444444">您理解并同意，</span
        ><span style="font-family:Helvetica; color:#444444">“咔嚓”</span
        ><span style="font-family:宋体; color:#444444"
          >有权依合理判断对违反有关法律法规或本协议规定的行为进行处罚，对违法违规的任何用户采取适当的法律行动，并依据法律法规保存有关信息向有关部门报告等，您应承担由此而产生的相应法律责任。</span
        >
      </p>
      <ol start="11" type="1" style="margin:0pt; padding-left:0pt">
        <li
          style="margin-top:12pt; margin-bottom:12pt; text-align:left; widows:2; orphans:2; font-family:Helvetica; font-size:12pt; font-weight:bold; color:#444444; background-color:#ffffff"
        >
          <span style="font-family:宋体">11. 知识产权声明</span>
          <ol type="1" class="awlist5" style="margin-right:0pt; margin-left:0pt; padding-left:0pt">
            <li
              style="margin-top:12pt; margin-left:22.5pt; margin-bottom:12pt; text-indent:-22.5pt; font-weight:normal; background-color:#ffffff; -aw-list-padding-sml:1.5pt"
            >
              <span
                style="width:1.5pt; font:7pt 'Times New Roman'; display:inline-block; -aw-import:ignore"
              >
              </span
              ><span>11.1 “咔嚓”</span
              ><span style="font-family:宋体"
                >本身自带的所有版本、技术、程序、道具和所有的信息内容（</span
              ><span>“咔嚓”</span
              ><span style="font-family:宋体"
                >信息内容，包括但不限于产品功能、用户界面、操作步骤、商标、专利、计算机软件作品、网页、文字、图片、音频、视频、图表等）的知识产权均归</span
              ><span>“咔嚓”</span><span style="font-family:宋体">、 </span><span>“咔嚓”</span
              ><span style="font-family:宋体">许可方所有，</span><span>“咔嚓”</span
              ><span style="font-family:宋体"
                >对您的软件使用许可在任何情况下均不应视为向您转让其知识产权的部分或者全部。</span
              >
            </li>
            <li
              style="margin-top:12pt; margin-left:22.5pt; margin-bottom:12pt; text-indent:-22.5pt; font-weight:normal; background-color:#ffffff; -aw-list-padding-sml:1.5pt"
            >
              <span
                style="width:1.5pt; font:7pt 'Times New Roman'; display:inline-block; -aw-import:ignore"
              >
              </span
              ><span style="font-family:宋体; -aw-import:spaces">&nbsp;</span
              ><span style="font-family:宋体">11.2 您在使用</span><span>“咔嚓”</span
              ><span style="font-family:宋体"
                >时注册的帐号、昵称以及发表上传的文字、图片、视频、音频等各种形式的内容和信息均由您原创或已获合法授权（且含转授权），此部分信息的知识产权归您所有，责任由您承担。您的发表、上传行为视为对</span
              ><span>“咔嚓”</span><span style="font-family:宋体">的授权，您理解并同意授予</span
              ><span>“咔嚓”</span
              ><span style="font-family:宋体"
                >及其关联公司全球范围内免费、非独家、永久、可转授权和可再许可的权利，包括但不限于：复制权、发行权、出租权、展览权、表演权、放映权、广播权、信息网络传播权、摄制权、改编权、翻译权、汇编权以及《著作权法》规定的由著作权人享有的其他著作财产权利及邻接权利。</span
              ><span>“咔嚓”</span
              ><span style="font-family:宋体"
                >可自行选择是否使用以及使用方式，包括但不限于将前述信息在</span
              ><span>“咔嚓”</span
              ><span style="font-family:宋体"
                >平台上使用与传播，将上述信息再次编辑后使用，以及由</span
              ><span>“咔嚓”</span
              ><span style="font-family:宋体"
                >授权给合作方使用、编辑与传播等。为避免疑义，您理解并同意，上述授予的权利包括使用、复制和展示您拥有或被许可使用并植入内容和信息中的个人形象、肖像、姓名、商标、服务标志、品牌、名称、标识和公司标记（如有）以及任何其他品牌、营销或推广资产、物料、素材等的权利和许可。</span
              >
            </li>
          </ol>
        </li>
        <li
          style="margin-top:12pt; margin-bottom:12pt; text-align:left; widows:2; orphans:2; font-family:Helvetica; font-size:12pt; font-weight:bold; color:#444444; background-color:#ffffff"
        >
          <span style="font-family:宋体">12. 不可抗力与其他免责事由</span>
        </li>
      </ol>
      <p
        style="margin-top:12pt; margin-left:18pt; margin-bottom:12pt; text-align:left; widows:2; orphans:2; font-size:12pt; background-color:#ffffff"
      >
        <span style="font-family:Helvetica; color:#444444">“咔嚓”</span
        ><span style="font-family:宋体; color:#444444"
          >在使用中会受到包括但不限于如下不可抗力或者其他因素的影响：政治原因、社会环境、自然灾害、经济危机、计算机病毒或黑客攻击、服务器或系统不稳定、您所在的特殊位置、任何技术能力、网络质量以及通信线路、计算机故障等（以下统称</span
        ><span style="font-family:Helvetica; color:#444444">“</span
        ><span style="font-family:宋体; color:#444444">免责事由</span
        ><span style="font-family:Helvetica; color:#444444">”</span
        ><span style="font-family:宋体; color:#444444">）。</span
        ><span style="font-family:宋体; font-weight:bold; color:#444444"
          >若出现上述免责事由情况时，</span
        ><span style="font-family:Helvetica; font-weight:bold; color:#444444">“咔嚓”</span
        ><span style="font-family:宋体; font-weight:bold; color:#444444"
          >将尽努力在第一时间进行修复或者及时补救，给您造成损失的，</span
        ><span style="font-family:Helvetica; font-weight:bold; color:#444444">“咔嚓”</span
        ><span style="font-family:宋体; font-weight:bold; color:#444444"
          >在法律与政策允许的范围内免责。您理解并确认，在使用本服务过程中存在来自任何他人的包括误导性的、欺骗性的、威胁性的、诽谤性的、令人反感的或非法的信息，或侵犯他人权利的匿名或冒名的信息，以及伴随该等信息的行为，因此导致的您或第三方的任何损失，</span
        ><span style="font-family:Helvetica; font-weight:bold; color:#444444">“咔嚓”</span
        ><span style="font-family:宋体; font-weight:bold; color:#444444"
          >不承担任何责任。您理解并确认，</span
        ><span style="font-family:Helvetica; font-weight:bold; color:#444444">“咔嚓”</span
        ><span style="font-family:宋体; font-weight:bold; color:#444444">需要定期或不定期地对</span
        ><span style="font-family:Helvetica; font-weight:bold; color:#444444">“咔嚓”</span
        ><span style="font-family:宋体; font-weight:bold; color:#444444"
          >平台或相关的设备进行检修或者维护，如因此类情况而造成服务在合理时间内的中断，</span
        ><span style="font-family:Helvetica; font-weight:bold; color:#444444">“咔嚓”</span
        ><span style="font-family:宋体; font-weight:bold; color:#444444"
          >将无法为此承担任何责任，但</span
        ><span style="font-family:Helvetica; font-weight:bold; color:#444444">“咔嚓”</span
        ><span style="font-family:宋体; font-weight:bold; color:#444444"
          >应事先进行通告。在任何情况下，</span
        ><span style="font-family:Helvetica; font-weight:bold; color:#444444">“咔嚓”</span
        ><span style="font-family:宋体; font-weight:bold; color:#444444"
          >均不对任何间接性、后果性、惩罚性、偶然性、特殊性或刑罚性的损害，包括因您使用本服务而遭受的利润损失，承担责任（即使</span
        ><span style="font-family:Helvetica; font-weight:bold; color:#444444">“咔嚓”</span
        ><span style="font-family:宋体; font-weight:bold; color:#444444"
          >已被告知该等损失的可能性亦然）。尽管本协议中可能含有相悖的规定，</span
        ><span style="font-family:Helvetica; font-weight:bold; color:#444444">“咔嚓”</span
        ><span style="font-family:宋体; font-weight:bold; color:#444444"
          >对您承担的全部责任，无论因何原因或何种行为方式，始终不超过您因使用本服务而支付给</span
        ><span style="font-family:Helvetica; font-weight:bold; color:#444444">“咔嚓”</span
        ><span style="font-family:宋体; font-weight:bold; color:#444444">的费用</span
        ><span style="font-family:Helvetica; font-weight:bold; color:#444444">(</span
        ><span style="font-family:宋体; font-weight:bold; color:#444444">如有</span
        ><span style="font-family:Helvetica; font-weight:bold; color:#444444">)</span
        ><span style="font-family:宋体; font-weight:bold; color:#444444">。</span>
      </p>
      <ol start="13" type="1" style="margin:0pt; padding-left:0pt">
        <li
          style="margin-top:12pt; margin-bottom:12pt; text-align:left; widows:2; orphans:2; font-family:Helvetica; font-size:12pt; font-weight:bold; color:#444444; background-color:#ffffff"
        >
          <span style="font-family:宋体">13. 服务的变更、中断和终止</span>
          <ol type="1" class="awlist6" style="margin-right:0pt; margin-left:0pt; padding-left:0pt">
            <li
              style="margin-top:12pt; margin-left:22.5pt; margin-bottom:12pt; text-indent:-22.5pt; font-weight:normal; background-color:#ffffff; -aw-list-padding-sml:1.5pt"
            >
              <span
                style="width:1.5pt; font:7pt 'Times New Roman'; display:inline-block; -aw-import:ignore"
              >
              </span
              ><span style="font-family:宋体">13.1 您理解并同意，我们提供的</span><span>“咔嚓”</span
              ><span style="font-family:宋体"
                >软件及相关服务是按照现有技术和条件所能达到的现状提供的。我们会尽最大努力向您提供服务，确保服务的连贯性和安全性。您理解，我们不能随时或始终预见和防范法律、技术以及其他风险，包括但不限于不可抗力、网络原因、第三方服务瑕疵、第三方网站等原因可能导致的服务中断、不能正常使用</span
              ><span>“咔嚓”</span
              ><span style="font-family:宋体">软件及相关服务以及其他的损失和风险。</span>
            </li>
            <li
              style="margin-top:12pt; margin-left:22.5pt; margin-bottom:12pt; text-indent:-22.5pt; font-weight:normal; background-color:#ffffff; -aw-list-padding-sml:1.5pt"
            >
              <span
                style="width:1.5pt; font:7pt 'Times New Roman'; display:inline-block; -aw-import:ignore"
              >
              </span
              ><span style="font-family:宋体"
                >13.2
                您理解并同意，我们为了整体服务运营、平台运营安全的需要，有权视具体情况决定服务</span
              ><span>/</span
              ><span style="font-family:宋体">功能的设置及其范围修改、中断、中止或终止</span
              ><span>“咔嚓”</span><span style="font-family:宋体">软件及相关服务。</span>
            </li>
            <li
              style="margin-top:12pt; margin-left:22.5pt; margin-bottom:12pt; text-indent:-22.5pt; font-weight:normal; background-color:#ffffff; -aw-list-padding-sml:1.5pt"
            >
              <span
                style="width:1.5pt; font:7pt 'Times New Roman'; display:inline-block; -aw-import:ignore"
              >
              </span
              ><span style="font-family:宋体">13.3 除其他协议另有规定外，</span><span>“咔嚓”</span
              ><span style="font-family:宋体"
                >不对相应变更、中断或终止承担任何责任，您应妥善做好数据备份与转移工作。</span
              >
            </li>
          </ol>
        </li>
        <li
          style="margin-top:12pt;margin-bottom:12pt; text-align:left; widows:2; orphans:2; font-family:Helvetica; font-size:12pt; font-weight:bold; color:#444444; background-color:#ffffff"
        >
          <span style="font-family:宋体">14. 适用法律与纠纷管辖</span>
        </li>
      </ol>
      <p
        style="margin-top:12pt; margin-left:18pt; margin-bottom:12pt; text-align:left; widows:2; orphans:2; font-size:12pt; background-color:#ffffff"
      >
        <span style="font-family:宋体; font-weight:bold; color:#444444"
          >本协议成立、生效、履行、解释及纠纷解决，均适用中华人民共和国大陆地区法律（不包括冲突法）。本协议签订地为中华人民共和国北京市朝阳区。若在您与</span
        ><span style="font-family:Helvetica; font-weight:bold; color:#444444">“咔嚓”</span
        ><span style="font-family:宋体; font-weight:bold; color:#444444"
          >之间发生的任何纠纷或争议，双方同意提交本协议签订地北京市朝阳区有管辖权的人民法院诉讼解决。</span
        >
      </p>
      <ol start="15" type="1" style="margin:0pt; padding-left:0pt">
        <li
          style="margin-top:12pt;; margin-bottom:12pt; text-align:left; widows:2; orphans:2; font-family:Helvetica; font-size:12pt; font-weight:bold; color:#444444; background-color:#ffffff"
        >
          <span style="font-family:宋体">15. 其他</span>
        </li>
      </ol>
      <p
        style="margin-top:12pt; margin-left:18pt; margin-bottom:12pt; text-align:left; widows:2; orphans:2; font-size:12pt; background-color:#ffffff"
      >
        <span style="font-family:宋体; color:#444444">由于互联网高速发展，您与</span
        ><span style="font-family:Helvetica; color:#444444">“咔嚓”</span
        ><span style="font-family:宋体; color:#444444"
          >签署的本协议列明的条款可能并不能完整罗列并覆盖您与</span
        ><span style="font-family:Helvetica; color:#444444">“咔嚓”</span
        ><span style="font-family:宋体; color:#444444"
          >所有权利与义务，现有的约定也不能保证完全符合未来发展的需求。因此，隐私政策、平台行为规范及各类规则、公告或通知等均为本协议的补充协议，与本协议不可分割且具有同等法律效力。如您使用</span
        ><span style="font-family:Helvetica; color:#444444">“咔嚓”</span
        ><span style="font-family:宋体; color:#444444">平台服务，视为您同意上述补充协议。</span
        ><span style="font-family:Helvetica; color:#444444">“咔嚓”</span
        ><span style="font-family:宋体; color:#444444"
          >可能根据法律与政策要求，或自身对商业等要素的判断，随时更新本协议及补充协议，届时我们将会通过网页公示或等方式告知您，您也可在</span
        ><span style="font-family:Helvetica; color:#444444">“咔嚓”</span
        ><span style="font-family:宋体; color:#444444"
          >内查阅最新版协议条款；若您无法接受本协议未来更新版本的全部或者部分条款，您可以随时停止使用</span
        ><span style="font-family:Helvetica; color:#444444">“咔嚓”</span
        ><span style="font-family:宋体; color:#444444">提供的服务，您继续使用</span
        ><span style="font-family:Helvetica; color:#444444">“咔嚓”</span
        ><span style="font-family:宋体; color:#444444">提供的服务将被视为接受修改后的协议。</span>
      </p>
      <p style="margin-top:0pt; margin-bottom:0pt"><span style="-aw-import:ignore">&nbsp;</span></p>
      <p style="margin-top:0pt; margin-bottom:0pt"><span style="-aw-import:ignore">&nbsp;</span></p>
    </div>
  </div>
</template>


<style lang="scss">
.root {
  padding: 20px 30px 0 30px;
  width: 690px;
  text-align: left;
  color: black;
  font-size: 30px;
  background: white;

  a {
    color: blue;
  }
}
.ql-editor {
  p {
    strong {
      // margin: 20px auto;
    }
    span {
      display: block;
      text-align: left;
    }
  }
}
</style>

<script>
export default {};
</script>
